import { labelStyle, groupStyle, focusStyle } from "./fieldStyles";

const TextArea = ({ formik, formClass, label, valueName, rows, style }) => {
  return (
    <div style={{ ...groupStyle, ...style }}>
      <style>{focusStyle}</style>
      {label && <label htmlFor={valueName} style={labelStyle}>{label}</label>}
      <textarea
        id={valueName}
        className={`field-modern${formik.errors[valueName] ? " is-invalid" : ""}`}
        placeholder={label}
        rows={rows || 3}
        name={valueName}
        value={formik.values[valueName] ?? ""}
        onChange={formik.handleChange}
        style={{ resize: "vertical" }}
      />
      {formik.errors[valueName] && (
        <span style={{ fontSize: "0.75rem", color: "#c62828", marginTop: "3px" }}>{formik.errors[valueName]}</span>
      )}
    </div>
  );
};

export default TextArea;
